import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable()
export class RelatedPartyChangeSystemAcctService {

  constructor(private http: HttpClient) { }

  loadCategories(
    baseUrl: string,
    globalService: any,
    filterParams: any = {},
    rowData: any = {},
    userSettings: any = {}
  ): Observable<any> {
    let params: any = _.merge({}, globalService, filterParams);

    params.action_code = 'tykclb';
    params.tax_year = filterParams.tax_year || params.tax_year;
    params.scenario = filterParams.scenario || params.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || 250;

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${baseUrl}/loadJsonObject`;

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveCategoryUpdate(
    baseUrl: string,
    clob_settings: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {},
    userSettings: any = {}
  ): Observable<any> {
    // Build params exactly like AngularJS
    let params: any = _.merge({}, globalService, filterParams);

    const jsonObj = JSON.stringify(clob_settings);
    const jsonSettings = JSON.stringify(clob_settings);

    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = "UPDATE_CATEGORY_DATA";
    params.sso_id = userSettings?.user?.sso_id || '';
    
    // CRITICAL: Required parameters
    params.tax_year = filterParams.tax_year || params.tax_year || globalService.tax_year;
    params.scenario = filterParams.scenario || params.scenario || globalService.scenario;
    params.jcd_key = filterParams.jcd_key || params.jcd_key || globalService.jcd_key || 250;
    params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || params.scenarioCode || 'RAF';
    params.is_issue_key_enabled = 'N';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const url = `${baseUrl}/saveJsonObject?action_code=7fgs26`;

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

